import React, { useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,

} from "@mui/material";
import { withRouter } from "../../../providers/withRouter";
import { getOneAAFF } from "../../../services";
import ObservacionesTecnico from "../../../components/aaff/observacionesTecnico";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import ListadoComunidades from "./ListadoComunidades";
import { cambiarFormatoNombre } from "../../../functions/funciones";
import { CircularProgress } from '@mui/material';
import ModalEditar from "./../admin/editarDatosAAFF";
import Editar from "../../../icons/editar.svg";



const DetallesAAFF = ({ params }) => {
  const { t } = useTranslation(['aaff', 'properties', 'common']);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [info, setInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true)

  const [recargar, setRecargar] = useState(true);


  useEffect(() => {
    fetchAAFFInfo();
    
  }, [recargar]);

  const fetchAAFFInfo = async () => {
    // setRecargar(false);
    try {
      const response = await getOneAAFF(params?.nif) || {};
const { nombre, apellidos } = (Array.isArray(response?.consultants) 
    ? response.consultants.find(item => item?.r_consul_servsgroups_aaffs?.group_id === 1) || {} 
    : {});
const nombreSeguro = nombre ?? '';
const apellidosSeguro = apellidos ?? '';
      setInfo(response);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };




  return isLoading ? <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
    <>
      <ModalEditar
        aaff={info}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      <BreadCrumb rutas={[{ path: '/aaff', label: t('titleSingular') }, { path: '/aaff', label: `${info && info.razonSocial}` }]} style={{ margin: '0 10px' }} />
      <Box className="listPage">
        <div className="gridCard">
          <div className="gridHead" style={{ backgroundColor: "#92004D" }}>
            <Typography fontWeight="bold">{t('details.generalInfo')}</Typography>
          </div>
        </div>
        <Box sx={{ mb: 10 }}>
          <Box
            className="lae-flex lae-flex-column"
            sx={{
              backgroundColor: "#fff",
              mb: 1,
              borderRadius: "0 0 10px 10px",
              boxShadow: "0.1px 2px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="gridSubhead editarSubhead">
              <div>{t('details.companyData')}</div>
              <div className="btnsSubhead">
                <div className="editarBtn" onClick={() => setModalEditarOpened(true)} >
                  <span style={{ marginRight: 10 }}>{t('details.edit')}</span>{" "}
                  <img src={Editar} alt={t('common:actions.edit')} />
                </div>
              </div>
            </div>
            <Box className="lae-flex lae-flex-row" sx={{padding: 2 }}>
              <Box className="lae-flex lae-flex-column" sx={{ flex: 3.3}}>
                <Typography><b>{t('details.name')}:</b> {info?.razonSocial}</Typography>
                <Typography><b>{t('common:form.phone')}:</b> {info?.telefono}</Typography>
                <Typography><b>{t('common:form.email')}:</b> {info?.user?.email}</Typography>
                <Typography><b>{t('details.contactEmail')}:</b> {info?.correoContacto}</Typography>
                <Typography><b>{t('common:form.municipality')}:</b> {cambiarFormatoNombre(info?.municipio)}</Typography>
                {(() => {
                  const { nombre = '', apellidos = '' } = info?.technicians?.find(
                    item => item.r_tech_aaffs?.group_id === 1
                  ) || {};
                  const nombreCompleto = `${nombre} ${apellidos}`.trim();

                  return (
                    <Typography>
                      <b>{t('details.technician')}:</b> {nombreCompleto || t('common:status.notAssigned')}
                    </Typography>
                  );
                })()}
              </Box>
              <Box className="lae-flex lae-flex-column" sx={{ flex: 3.3 }}>
                {!info?.parent_id && (
                  <Typography><b>{t('common:form.nif')}:</b> {info?.nif}</Typography>
                )}
                <Typography>
                  <b>{t('details.contactPerson')}:</b> {info?.nombreContacto}
                </Typography>
                <Typography><b>{t('common:form.province')}:</b> {info?.provincia}</Typography>
                {(() => {
                  const { nombre = '', apellidos = '' } = info?.consultants?.find(
                    item => item.r_consul_servsgroups_aaffs?.group_id === 1
                  ) || {};
                  const nombreCompleto = `${nombre} ${apellidos}`.trim();
                  
                  return (
                    <Typography>
                      <b>{t('details.consultant')}:</b> {nombreCompleto || t('common:status.notAssigned')}
                    </Typography>
                  );
                })()}
                <Typography>
                  <b>{t('details.commercial')}:</b>
                  {info?.commercial === undefined
                    ? ''
                    : (info?.commercial?.nombre === undefined
                      ? ''
                      : ` ${info?.commercial?.nombre} `) +
                    (info?.commercial?.apellidos === undefined
                      ? ''
                      : ` ${info?.commercial?.apellidos}`) +
                    (info?.commercial?.user?.[0]?.email === undefined
                      ? ''
                      : ` (${info.commercial.user[0].email})`)
                  }
                </Typography>



              </Box>

            </Box>
            <hr />
            <div className="datosGrid">
              <ObservacionesTecnico aaff={info} />
            </div>
            <div className="gridSubhead editarSubhead">
              <div>{t('details.communitiesList')}</div>
            </div>
              <ListadoComunidades aaff={info} />
            {/* <div className="tableContainer">
            </div> */}
          </Box>


        </Box>
      </Box>
    </>
};

export default withRouter(DetallesAAFF);
